import { NotebookPen } from 'lucide-react';
import { cn } from '@jeraisonne/ui';

/**
 * « Mettre dans ma feuille » : pose une valeur d'un outil dans la ligne en
 * cours de la feuille de brouillon. Affiche le prix en HORA s'il y en a un.
 */
export function SendToSheetButton({
  label,
  cost,
  onClick,
  className,
}: {
  /** ce qui sera posé, pour le lecteur d'écran (« √2/2 ») */
  label: string;
  cost: number;
  onClick: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={
        cost > 0
          ? `Mettre ${label} dans ma feuille (coûte ${cost} HORA)`
          : `Mettre ${label} dans ma feuille`
      }
      title={
        cost > 0
          ? `Calculatrice non autorisée sur cet exercice : poser cette valeur coûte ${cost} HORA`
          : 'Poser cette valeur dans la ligne en cours'
      }
      className={cn(
        'bg-primary-50 text-primary-700 hover:bg-primary-100 inline-flex min-h-11 items-center gap-1.5 rounded-xl px-3 text-sm font-semibold transition-colors active:scale-[0.98]',
        className,
      )}
    >
      <NotebookPen className="h-4 w-4 shrink-0" aria-hidden />
      <span>Feuille</span>
      {cost > 0 && <span className="text-accent-700 text-xs font-bold">−{cost} HORA</span>}
    </button>
  );
}
